import {getAnalytics, logEvent} from 'firebase/analytics';
import {initializeApp} from 'firebase/app';

//Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBumL6-qBqPyCFJcNOU3_Y6Q-krMyK5p7s',
  authDomain: 'acepmobile-f41f3.firebaseapp.com',
  projectId: 'acepmobile-f41f3',
  storageBucket: 'acepmobile-f41f3.appspot.com',
  messagingSenderId: '922621189438',
  appId: '1:922621189438:web:50ee694a7bac3ce837e06f',
  measurementId: 'G-ZKCQ1HEJET',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const trackPageView = async screenName => {
  await logEvent(analytics, 'website_page_view', {
    screen_name: screenName,
  });
};

export const trackPOCTool = async (itemId: string, itemTitle: string) => {
  await logEvent(analytics, 'POCTool_Website', {
    POCTool_Id: itemId,
    POCTool_Title: itemTitle,
  });
};

export const trackPOCToolCategory = async (
  itemId: string,
  categoryName: string,
) => {
  await logEvent(analytics, 'POCTool_Website', {
    POCTool_Title: `${itemId}- ${categoryName}`,
  });
};
